import { isLikelyAccessory as detectIsLikelyAccessory } from './accessoryDetection';

const ALL_STORE_COUNTRIES = ['US', 'GB', 'DE', 'FR', 'IT', 'ES', 'PL', 'AU', 'CN', 'AMZ'];
const ALL_COUNTRIES = ALL_STORE_COUNTRIES;
const ALL_PLATFORMS = ['eBay', 'AliExpress', 'amazon'];
const ALL_CONDITIONS = ['NEW', 'USED', 'REFURBISHED'];

export function isLikelyAccessory(product, searchQuery = '') {
  return detectIsLikelyAccessory(product, searchQuery);
}

export function getRelevantProductsForHistogram(products, hideAccessories = false, searchQuery = '') {
  if (!hideAccessories) {
    return products || [];
  }
  return (products || []).filter(
    (product) => !isLikelyAccessory(product, searchQuery)
  );
}

export const DEFAULT_FILTERS = {
  countries: [],
  platforms: [],
  minPrice: null,
  maxPrice: null,
  conditions: [],
  hideAccessories: false,
};

export function filterProducts(products, filters, searchQuery = '') {
  if (!products || !products.length) {
    return [];
  }

  const activeCountries =
    filters.countries && filters.countries.length
      ? filters.countries
      : ALL_COUNTRIES;
  const activePlatforms =
    filters.platforms && filters.platforms.length
      ? filters.platforms
      : ALL_PLATFORMS;
  const hasConditionFilter = !!(filters.conditions && filters.conditions.length);
  const activeConditions = hasConditionFilter ? filters.conditions : ALL_CONDITIONS;
  const minPrice = filters.minPrice ? parseFloat(filters.minPrice) : null;
  const maxPrice = filters.maxPrice ? parseFloat(filters.maxPrice) : null;
  const hideAccessories = filters.hideAccessories === true;

  return products
    .map((product) => {
      let stores = (product.otherStores || []).filter(
        (store) => {
          const condition = (store.condition || store.itemCondition || 'NEW').toUpperCase();
          return (
            activeCountries.includes(store.country) &&
            activePlatforms.includes(store.retailer) &&
            (!hasConditionFilter || activeConditions.includes(condition))
          );
        }
      );

      if (!stores.length) {
        return null;
      }

      const cheapest = Math.min(
        ...stores.map((s) => parseFloat(s.price.calcTotalPrice) || Infinity)
      );

      if (minPrice && cheapest < minPrice) {
        return null;
      }

      if (maxPrice && cheapest > maxPrice) {
        return null;
      }

      return { ...product, otherStores: stores };
    })
    .filter(Boolean)
    .filter((product) => !hideAccessories || !isLikelyAccessory(product, searchQuery));
}

export function getPriceBounds(products) {
  const prices = (products || [])
    .flatMap((product) => product.otherStores || [])
    .map((store) => parseFloat(store.price && store.price.calcTotalPrice))
    .filter((price) => Number.isFinite(price) && price > 0);

  if (!prices.length) {
    return { min: 0, max: 1000 };
  }

  return {
    min: Math.floor(Math.min(...prices)),
    max: Math.ceil(Math.max(...prices)),
  };
}

export function hasActiveFilters(filters) {
  if (!filters) {
    return false;
  }

  return !!(
    (filters.countries && filters.countries.length)
    || (filters.platforms && filters.platforms.length)
    || (filters.conditions && filters.conditions.length)
    || filters.minPrice != null
    || filters.maxPrice != null
    || filters.hideAccessories === true
  );
}

export { ALL_COUNTRIES, ALL_PLATFORMS, ALL_CONDITIONS };
